export const isCreditMemoPayment = (payment) => payment?.paymentType === 'Credit Memo' || payment?.sourceTransactionType === 'Credit Memo';

// Credit memo headers belong to the source document; this editor only changes applications.
export const savePaymentReviewChanges = (api, payment, form, allocations) => (
  isCreditMemoPayment(payment)
    ? api.post(`/payments/${payment.id}/reallocate`, { allocations })
    : api.patch(`/payments/${payment.id}`, { ...form, amount: Number(form.amount), allocations })
);
